import React, { useEffect, useState } from 'react';
import useApp from 'hooks/useApp'
import wooriSymbol from 'images/tmp_woori_symbol.png'
import companyImg from 'images/tmp_company.png'
import styles from './index.module.css'

const CompanyDetail1 = () => {

	const App = useApp()
	const [tabList, setTabList] = useState(0)

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: "",
			right: <i className="icon icon_close" />
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_1">
				<div className="shadow">
					<div className="padding pt_40 pb_50">
						<div className={`${styles["company-title"]} align_start`}>
							<div className={styles["detail-title"]}>
								<span className={styles.tag}>#기업규모</span>
								<div className="mt_5">주식회사 모니</div>
								<span className={`${styles.number} mt_5`}>(1138653976)</span>

								{/* 폐업인 경우 태그 노출 */}
								<div className="mt_10">
									<i className="tag tag-box tag-red">폐업</i>
								</div>

								{/* 휴업인 경우 태그 노출 */}
								<div className="mt_10">
									<i className="tag tag-box tag-gray">휴업</i>
								</div>
							</div>

							<div className="img-box img-symbol img-symbol-lg">
								<img src={wooriSymbol} alt="" />
							</div>

							{/* 폐업인 경우 이미지 노출 */}
							{/* <div className={`${styles["company-stop"]} img-box img-symbol img-symbol-lg`}>
							<i className="icon icon_shut_down" />
						</div> */}
						</div>
					</div>
				</div>

				<div className="padding pt_40">
					<ul className="tab-round">
						<li onClick={() => setTabList(0)} className={tabList === 0 ? "active" : ""}>기업정보</li>
						<li onClick={() => setTabList(1)} className={tabList === 1 ? "active" : ""}>재무정보</li>
					</ul>
					<ul className="my-info-box px_10 mt_40">
						<li>
							<span>업력</span>
							<div className="flex-column align_center mt_10">
								<strong>20년</strong>
								<span className="mt_5">(2000.09 설립)</span>
							</div>
						</li>
						<li>
							<span>사원수</span>
							<div className="flex-column align_center mt_10">
								<strong>496,000명</strong>
								<span className="mt_5">(2020.06 기준)</span>
							</div>
						</li>
						<li>
							<span>상장</span>
							<div className="flex-column align_center mt_10">
								<strong>코스피</strong>
								<span className="mt_5">(2021.08.06)</span>
							</div>
						</li>
					</ul>
					<ul className="list-item mt_30" style={{ fontSize: "1.4rem" }}>
						<li>
							<span>산업</span>
							<span>컴퓨터 프로그래밍 서비스업</span>
						</li>
						<li>
							<span>주요사업</span>
							<span>소프트웨어개발 및 공급</span>
						</li>
						<li>
							<span>대표자</span>
							<span>김모니</span>
						</li>
						<li>
							<span>법인등록번호</span>
							<span>110114730671</span>
						</li>
					</ul>
					<hr className="my_40" />
					<ul className="list-item mt_30" style={{ fontSize: "1.4rem" }}>
						<li>
							<span>홈페이지</span>
							<span className={styles["btn-txt"]} style={{ fontSize: "1.4rem" }}>http://www.yangcheon.go.kr/</span>
						</li>
						<li>
							<span>전화번호</span>
							<span className={styles["btn-txt"]} style={{ fontSize: "1.4rem" }}>031-8078-8025</span>
						</li>
						<li>
							<span>팩스번호</span>
							<span>-</span>
						</li>
						<li>
							<span>회사주소</span>
							<span>서울 영등포구 여의대로(08104) <i className="icon icon_copy ml_5" /></span>
						</li>
					</ul>
					<div className="img-box mt_40" style={{ height: "20rem" }}>
						<img src={companyImg} alt="" />
					</div>
				</div>
			</div>
			<div className="flex-shrink_0 padding">
				<div className={styles["guide-bottom"]}>NICE평가정보에서 받아오는 정보입니다.</div>
			</div>
		</div>
	)
}

export default CompanyDetail1